import React from 'react';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import { Field, reduxForm } from 'redux-form';
import Row from '../../../shared/components/Row';
import { FormSubmit } from '../../../shared/components/FormSubmit';
import { FormText } from '../../../shared/components/FormText';
import { CompanyFormValidator } from './CompanyFormValidator';
import PropTypes from 'prop-types';

const FORM = {
    NAME: 'CompanyForm',
    FIELDS: {
        NAME: 'name',
        NIF: 'nif',
        PHONE: 'phone',
        CCC: 'ccc',
        CONTACT_PERSON: 'contactPerson',
        EMAIL: 'email',
        ADDRESS: 'address',
    },
};

class CompanyFormContent extends React.Component {

    render() {
        const {
            canWrite,
            onSubmit,
            handleSubmit,
        } = this.props;

        return (
            <form onSubmit={handleSubmit(onSubmit)}>
                <Row>
                    <Field
                        col="col-sm-6"
                        type="text"
                        name={FORM.FIELDS.NAME}
                        label={I18nUtils.tr('TR_RAZON_SOCIAL') + ':'}
                        placeholder={I18nUtils.tr('TR_RAZON_SOCIAL')}
                        component={FormText}
                        disabled={!canWrite}
                    />
                    <Field
                        col="col-sm-6"
                        type="text"
                        name={FORM.FIELDS.NIF}
                        label={I18nUtils.tr('TR_NIF') + ':'}
                        placeholder={I18nUtils.tr('TR_NUMERO_DE_IDENTIFICACION_FISCAL')}
                        component={FormText}
                        disabled={!canWrite}
                    />
                </Row>
                <Row>
                    <Field
                        col="col-sm-6"
                        type="text"
                        name={FORM.FIELDS.PHONE}
                        label={I18nUtils.tr('TR_TELEFONO')}
                        placeholder={I18nUtils.tr('TR_TELEFONO')}
                        component={FormText}
                        disabled={!canWrite}
                    />
                    <Field
                        col="col-sm-6"
                        type="text"
                        name={FORM.FIELDS.CCC}
                        label={I18nUtils.tr('TR_CODIGO_CUENTA_COTIZACION_CCC')}
                        placeholder={I18nUtils.tr('TR_CODIGO_CUENTA_COTIZACION_CCC')}
                        component={FormText}
                        disabled={!canWrite}
                    />
                </Row>
                <Row>
                    <Field
                        col="col-sm-6"
                        type="text"
                        name={FORM.FIELDS.CONTACT_PERSON}
                        label={I18nUtils.tr('TR_PERSONA_DE_CONTACTO')}
                        placeholder={I18nUtils.tr('TR_PERSONA_DE_CONTACTO')}
                        component={FormText}
                        disabled={!canWrite}
                    />
                    <Field
                        col="col-sm-6"
                        type="text"
                        name={FORM.FIELDS.EMAIL}
                        label={I18nUtils.tr('TR_EMAIL')}
                        placeholder={I18nUtils.tr('TR_EMAIL')}
                        component={FormText}
                        disabled={!canWrite}
                    />
                </Row>
                <Row>
                    <Field
                        col="col-sm-12"
                        type="text"
                        label={I18nUtils.tr('TR_DIRECCION')}
                        placeholder={I18nUtils.tr('TR_DIRECCION')}
                        name={FORM.FIELDS.ADDRESS}
                        component={FormText}
                        disabled={!canWrite}
                    />
                </Row>
                {canWrite &&
                <Row>
                    <Field
                        col="col-md-6 col-md-offset-6"
                        name="submit"
                        label={I18nUtils.tr('TR_GUARDAR')}
                        component={FormSubmit}
                    />
                </Row>}
            </form>
        );
    }

}

export const CompanyForm = reduxForm({
    form: FORM.NAME,
    validate: CompanyFormValidator.validate,
})(CompanyFormContent);

CompanyForm.propTypes = {
    canWrite: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    initialValues: PropTypes.object.isRequired,
};

CompanyForm.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/my-company/company/form/CompanyForm.jsx